"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _affix = _interopRequireDefault(require("antd/lib/affix"));

var _DecoratorsRoot = require("../layout/DecoratorsRoot");

var _menu = _interopRequireDefault(require("../menu"));

var _propTypes2 = require("../constants/propTypes");

var _class, _class2, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("./styles/index.less");

var styles = {
  "root": "meepshop-meep-ui__fixedTop-index__root"
};

var FixedTop = (0, _DecoratorsRoot.enhancer)(_class = (_temp = _class2 = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(FixedTop, _React$PureComponent);

  var _super = _createSuper(FixedTop);

  function FixedTop() {
    (0, _classCallCheck2["default"])(this, FixedTop);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(FixedTop, [{
    key: "render",
    value: function render() {
      var menu = this.props.menu;
      if (!menu) return null;
      var iconSize = menu.iconSize,
          logoAlignment = menu.logoAlignment,
          pages = menu.pages,
          design = menu.design;
      return /*#__PURE__*/_react["default"].createElement(_affix["default"], {
        offsetTop: 0
      }, /*#__PURE__*/_react["default"].createElement("header", {
        className: styles.root
      }, /*#__PURE__*/_react["default"].createElement(_menu["default"], {
        id: "fixedTop" // 實際編譯出來會是 menu-fixedTop
        ,
        pages: pages,
        design: _objectSpread(_objectSpread({}, design), {}, {
          width: 0
        }),
        iconSize: iconSize,
        logoAlignment: logoAlignment,
        hasLevelThree: true
      })));
    }
  }]);
  return FixedTop;
}(_react["default"].PureComponent), (0, _defineProperty2["default"])(_class2, "propTypes", {
  /** props */
  menu: _propTypes["default"].shape({
    iconSize: _propTypes["default"].oneOf([24, 32, 48]).isRequired,
    logoAlignment: _propTypes["default"].oneOf(['LEFT', 'RIGHT']).isRequired,
    pages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      id: _propTypes2.ID_TYPE.isRequired
    }).isRequired),
    design: _propTypes["default"].shape({}).isRequired
  }).isRequired
}), _temp)) || _class;

exports["default"] = FixedTop;